
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ICON_PPT",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"ICON_PPT","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 70.108 73.79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"data-name":"Path 3142","d":"M68.256-.001H1.845A1.845 1.845 0 00-.002 1.845v55.343a1.846 1.846 0 001.845 1.845h28.755L18.991 70.644a1.844 1.844 0 002.612 2.6L33.21 61.637v10.3a1.845 1.845 0 003.689 0v-10.3l11.607 11.607a1.844 1.844 0 002.612-2.6L39.511 59.033h28.752a1.845 1.845 0 001.845-1.845V1.845a1.845 1.845 0 00-1.844-1.846zM3.689 3.688h62.722v44.275H3.69zm62.722 51.654H3.69v-3.689h62.722z"}})])
          )
        }
      }
    